import { createContext } from "react";
import type { CognitoTokens } from "@/shared/auth/cognito";

export type AuthContextValue = {
  isAuthenticated: boolean;
  idToken: string | null;
  /** Persist tokens (in cookies) after a successful Cognito callback. */
  setTokens: (tokens: CognitoTokens) => void;
  /** Clear local auth state. For Cognito, call revoke + hosted UI logout where config is available (see MainLayout). */
  logout: () => void;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
